/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-prototype-builtins */
/* eslint-disable camelcase */
import React, { Component, Fragment, createRef } from "react";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import { Link } from "react-router";
import axios from "axios";
import MaskedInput from "react-text-mask";
import { RKPayRibbon } from "@components/common";
import {
	JOBS_SUB_MENU,
	JOB_POSTED_TYPES,
	OFFICER_STATUSES,
	FORM_JOB_TYPES,
	JOB_INVOICED_TYPES,
} from "@constants";
import {
	JobService,
	OrganizationService,
	ClientService,
	ContactService,
	ProjectService,
	ZoneService,
	LocationService,
	TagService,
} from "@services";
import utils from "@utils";
import {
	ReactSelect,
	TabMenu,
	HeaderGrid,
	Switch,
	ManualAssignModal,
	BulkAssignModal,
	PostJobModal,
	SearchField,
	ScrollDetect,
	Image,
	ConfirmationModal,
} from "../../../components";
import {
	MultiPositionModal,
	JobSeriesDeleteModal,
	JobSeriesRestoreModal,
	JobsMapModal,
	ScheduleView,
} from "./components";
import AddToEstimateModal from "../../payments/AddToEstimate/AddToEstimateModal";

import "./JobsList.scss";

// Using a separate constant because the one in the constants file won't quite work right
const JOB_STATUSES = [
	{
		type: "active",
		status: 1,
		name: "active",
		countKey: "Active",
		displayName: "Active",
		description: "Jobs that are in progress or starting soon",
	},
	{
		type: "upcoming",
		status: 2,
		name: "upcoming",
		countKey: "Upcoming",
		displayName: "Upcoming",
		description: "Jobs scheduled for future dates",
	},
	{
		status: 2,
		type: "unstaffed",
		name: "unstaffed",
		countKey: "Unstaffed",
		displayName: "Unstaffed",
	},
	{
		status: 3,
		type: "completed",
		name: "completed",
		countKey: "Completed",
		displayName: "Completed",
		description: "Jobs that have been worked",
	},
];
const displayCount = 250;

let cancelCounts;
let cancelJobs;
class JobsList extends Component {
	constructor(props) {
		super(props);
		const {
			router: {
				params: { viewType },
			},
			location: { query },
		} = props;
		let dateRange = 7;
		if (query.dateRange === "custom" && query.startDate && query.endDate) dateRange = "custom";
		else if (!Number.isNaN(parseInt(query.dateRange, 10)))
			dateRange = parseInt(query.dateRange, 10);

		this.initialManualAssignModal = {
			show: false,
			defaultPosition: undefined,
			isActiveJob: false,
			agencyId: undefined,
			positions: [],
			assignedOfficers: {},
			applicants: {},
			recurrenceRule: undefined,
			isPrepayJob: false,
			isRKPayJob: false,
		};
		this.initialBulkAssignModal = {
			show: false,
			defaultPosition: undefined,
			isActiveJob: false,
			agencyId: undefined,
			positions: [],
			assignedOfficers: {},
			applicants: {},
			recurrenceRule: undefined,
			isPrepayJob: false,
			isRKPayJob: false,
		};

		this.initialMultiPositionModal = {
			show: false,
			job: {},
			assignmentsUpdated: false,
		};

		this.state = {
			showFilters: false,
			loadingCounts: true,
			searchingForJob: false,
			counts: {
				Active: "",
				Upcoming: "",
				Unstaffed: "",
				Completed: "",
			},
			hasMore: true,
			jobs: [],
			selectedJobs: [],
			pageNumber: 1,
			activeGrid: viewType || "active",
			loadingAgencies: true,
			agencies: [],
			loadingClients: true,
			clients: [],
			loadingProjects: false,
			projects: [],
			loadingZones: false,
			zones: [],
			loadingLocations: false,
			locations: [],
			loadingJobTags: false,
			jobTags: [],
			loadingSupervisors: false,
			supervisors: [],
			filters: {
				dateRange,
				startDate: query.startDate || "",
				endDate: query.endDate || "",
				agencyId: query.agencyId || "",
				clientId: query.clientId || "",
				projectId: query.projectId || "",
				locationId: query.locationId || "",
				zoneId: query.zoneId || "",
				jobTagId: query.jobTagId || "",
				jobInvoicedType: query.jobInvoicedType || 0,
				supervisorContactId: query.supervisorContactId || "",
				recurrenceId: query.recurrenceId || "",
				includeInactive: query.includeInactive === "true" || false,
				unStaffed: query.unStaffed === "true" || false,
				deleted: query.deleted === "true" || false,
				sortBy: query.sortBy || "StartDateTime",
				asc: query.asc === undefined,
				prePay: query.prePay === "true" || false,
				pendingApplicants: query.pendingApplicants === "true" || false,
				officerStatusFilters: query.officerStatusFilters || "",
			},
			multiPositionModal: { ...this.initialMultiPositionModal },
			manualAssignModal: { ...this.initialManualAssignModal },
			bulkAssignModal: { ...this.initialBulkAssignModal },
			isBulkAvailable: false,
			showPostJobModal: false,
			showJobSeriesDeleteModal: false,
			jobToRestoreSeries: undefined,
			deletingJob: undefined,
			bulkDeletingJobs: false,
			showMapModal: false,
			scheduleView: query.scheduleView === "true" || false,
			showAddToEstimateModal: false,
			jurisdictionPaymentRules: {
				transferPaymentToJurisdiction: false,
			},
		};

		this.confirmationModal = createRef();
		this.dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
	}

	// get initial data
	componentDidMount() {
		const {
			filters: { clientId },
		} = this.state;
		const { router, user } = this.props;
		document.addEventListener("click", this.clickEventListener);
		this.getAgencies();
		this.getClients();
		this.getTags();
		this.getPaymentRules();
		if (user.isLEA() && user.Organization.UseZones) this.getZones();
		// FE-1161: When the jobs list mounts, retrieve a list of supervisors only under the following conditions:
		// * User is a staff admin LEA
		// * User is a non-staff admin LEA but has a client preselected through query string params
		// * User is not an LEA
		if (
			(user.isLEA() && (user.IsStaffAdmin || (!user.IsStaffAdmin && clientId))) ||
			!user.isLEA()
		)
			this.getSupervisors();
		if (global.rkc?.jl) {
			this.setState(global.rkc.jl, () => {
				router.push(this.buildNewUrl());
				this.getJobCounts();
				this.updateExistingItems(true);
			});
		} else {
			this.getJobCounts();
		}
	}

	componentWillUnmount() {
		if (cancelCounts) cancelCounts();
		if (cancelJobs) cancelJobs();
		document.removeEventListener("click", this.clickEventListener);
		if (!global.rkc) global.rkc = {};
		global.rkc.jl = this.state;
	}

	/** Event listener that checks for clicks on the Jobs link in the navbar. Doing this resets all filters on the jobs list.
	 * @param {Event} event The HTML event handled by this method
	 */
	clickEventListener = ({ target }) => {
		const { user } = this.props;
		const path = target.href?.split("/") || [];
		if (path.length > 0 && path[path.length - 1] === "jobs") {
			this.setState(
				{
					hasMore: true,
					jobs: [],
					selectedJobs: [],
					pageNumber: 1,
					activeGrid: "active",
					filters: {
						dateRange: 7,
						agencyId: "",
						clientId: "",
						projectId: "",
						locationId: "",
						zoneId: "",
						jobTagId: "",
						supervisorContactId: "",
						recurrenceId: "",
						jobInvoicedType: 0,
						includeInactive: false,
						unStaffed: false,
						deleted: false,
						sortBy: "StartDateTime",
						asc: true,
						prePay: false,
						pendingApplicants: false,
						officerStatusFilters: "",
					},
					loadingAgencies: true,
					agencies: [],
					loadingClients: true,
					clients: [],
					loadingProjects: false,
					projects: [],
					loadingLocations: false,
					locations: [],
					loadingSupervisors: false,
					supervisors: [],
				},
				() => {
					this.getJobCounts();
					this.getJobs();
					this.getAgencies();
					this.getClients();
					if (user.isLEA() && user.Organization.UseZones) this.getZones();
					if ((user.isLEA() && user.IsStaffAdmin) || !user.isLEA()) this.getSupervisors();
				},
			);
		}
	};

	/**
	 * Updates the current jobs list in place without needing to refreshing the entire page
	 * @param {Boolean} clearCache indicates whether the global cache needs to be cleared after updating the list
	 */
	updateExistingItems = (clearCache = false) => {
		this.getJobCounts();
		const { pageNumber, filters, activeGrid } = this.state;
		const jobStatus = JOB_STATUSES.find(({ type: jobType }) => jobType === activeGrid);
		let startDate;
		let endDate;
		if (filters.dateRange === "custom" && utils.areCustomDatesValid()) {
			startDate =
				utils.isDesktopSafari || utils.isIE
					? filters.startDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.startDate;
			endDate =
				utils.isDesktopSafari || utils.isIE
					? filters.endDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.endDate;
		}

		// Cleaning up query params so that unecessary fields are not sent as part of the network request
		const queryParams = {
			startDate,
			endDate,
			pageNumber: 1,
			displayCount: (pageNumber - 1 || 1) * displayCount,
			dateRange: filters.dateRange,
			includeInactive: filters.includeInactive,
			deleted: filters.deleted,
			sortBy: filters.sortBy,
			asc: filters.asc,
			pendingApplicants: filters.pendingApplicants,
			agencyId: filters.agencyId || undefined,
			clientId: filters.clientId || undefined,
			projectId: filters.projectId || undefined,
			locationId: filters.locationId || undefined,
			zoneId: filters.zoneId || undefined,
			jobTagId: filters.jobTagId || undefined,
			jobInvoicedType: filters.jobInvoicedType || undefined,
			supervisorContactId: filters.supervisorContactId || undefined,
			recurrenceId: filters.recurrenceId || undefined,
			unStaffed: activeGrid === "unstaffed" || filters.unStaffed,
			prePay: filters.prePay || undefined,
			status: jobStatus.status,
			officerStatusFilters: filters.officerStatusFilters || undefined,
		};

		JobService.getAll(
			{
				getCancelToken: c => {
					cancelJobs = c;
				},
				...queryParams,
			},
			{ ignoreCache: true },
		)
			.then(({ data: { ItemList } }) => this.setState({ jobs: ItemList }))
			.catch(() => {})
			.finally(() => {
				if (clearCache) global.rkc.jl = undefined;
			});
	};

	getPaymentRules = () => {
		const { lang } = global;
		const { user } = this.props;
		if (!user.isLEA()) return;
		OrganizationService.getJurisdictionPaymentRules()
			.then(({ data }) => {
				const { TransferPaymentToJurisdiction } = data;
				this.setState(() => ({
					jurisdictionPaymentRules: {
						transferPaymentToJurisdiction: TransferPaymentToJurisdiction,
					},
				}));
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Payment Rules"),
					timeOut: 1500,
				}),
			);
	};

	/** Retrieves all agencies that the user can filter the job list by */
	getAgencies = () => {
		const { user } = this.props;
		// This select list is only available to Super Admins and LEAs
		if (!user.isSuperAdmin() && !user.isLEA()) return;
		this.setState({ loadingAgencies: true });
		OrganizationService.getAll({ minimalData: true })
			.then(({ data }) => {
				const agencies = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ agencies, loadingAgencies: false });
			})
			.catch(() => {
				this.setState({ agencies: [], loadingAgencies: false });
			});
	};

	/** Retrieves all clients that the user can filter the job list by */
	getClients = () => {
		const {
			filters: { includeInactive, agencyId },
		} = this.state;
		const { user } = this.props;
		if (user.isClient()) return;
		this.setState({ loadingClients: true });
		ClientService.getAll({ includeInactive, organizationId: agencyId })
			.then(({ data }) => {
				const clients = data.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ clients, loadingClients: false });
			})
			.catch(() => {
				this.setState({ clients: [], loadingClients: false });
			});
	};

	/** Retrieves all supervisors for the user's organization */
	getSupervisors = () => {
		const { user } = this.props;
		const {
			Organization: { Id: clientId },
		} = user;
		const {
			filters: { clientId: internalCoordClientId },
		} = this.state;
		// FE-1161: If the user is a non-staff admin LEA and a client has not yet been selected, do nothing.
		if (user.isLEA() && !user.IsStaffAdmin && !internalCoordClientId) return;
		this.setState({ loadingSupervisors: true });
		const params = {
			clientId,
			isOrganization: true,
			includeCoordinators: false,
			canSupervise: (user.isLEA() && !user.IsStaffAdmin) || undefined,
			internalCoordClientId,
		};
		ContactService.getAll(params)
			.then(({ data: { ItemList } }) => {
				const supervisors = ItemList.map(({ Id: value, ContactName: label }) => ({
					value,
					label,
				}));
				this.setState({ supervisors, loadingSupervisors: false });
			})
			.catch(() => {
				this.setState({ supervisors: [], loadingSupervisors: false });
			});
	};

	/**
	 * Retrieves all projects that the user can filter the job list by.
	 * Coordinators do not see project details, so this method is only called for non-coordinator users.
	 */
	getProjects = () => {
		const {
			filters: { includeInactive: includeAll, clientId },
		} = this.state;
		this.setState({ loadingProjects: true });
		ProjectService.getAll({ includeAll, clientId })
			.then(({ data: { ItemList } }) => {
				const projects = ItemList.map(({ Id: value, Name: label }) => ({ value, label }));
				this.setState({ projects, loadingProjects: false });
			})
			.catch(() => {
				this.setState({ projects: [], loadingProjects: false });
			});
	};

	/**
	 * Retrieves all locations that the user can filter the job list by.
	 *
	 * For non-coordinator users, the list of locations retrieved is based on the selected project.
	 * For coordinators, the list of locations is retrieved based on the selected client.
	 */
	getLocations = () => {
		const {
			filters: { projectId, clientId },
		} = this.state;
		const { user } = this.props;
		this.setState({ loadingLocations: true });
		try {
			if (user.isCoordinator()) {
				ClientService.getLocations(clientId).then(({ data }) => {
					const locations = data.map(({ Id: value, Name: label }) => ({ value, label }));
					this.setState({ locations, loadingLocations: false });
				});
			} else {
				LocationService.getAll({ minimalData: true, projectId }).then(({ data }) => {
					const locations = data.map(({ Id: value, Name: label }) => ({ value, label }));
					this.setState({ locations, loadingLocations: false });
				});
			}
		} catch (err) {
			this.setState({ locations: [], loadingLocations: false });
		}
	};

	/**
	 * Retrieves all zones that the user can filter the job list by.
	 *
	 * For lea users only.
	 */
	getZones = () => {
		const { user } = this.props;
		this.setState({ loadingZones: true });
		try {
			if (user.isLEA() && user.Organization.UseZones) {
				ZoneService.getAll().then(({ data }) => {
					const zones = data.map(({ Id: value, Name: label }) => ({ value, label }));
					this.setState({ zones, loadingZones: false });
				});
			}
		} catch (err) {
			this.setState({ zones: [], loadingZones: false });
		}
	};

	getTags = () => {
		this.setState({ loadingJobTags: true });
		try {
			TagService.getTags().then(({ data }) => {
				const jobTags = data.map(({ Id: value, Name: label }) => ({ value, label }));
				jobTags.unshift({ value: -1, label: '"Non-tagged jobs"' });
				this.setState({ jobTags, loadingJobTags: false });
			});
		} catch (err) {
			this.setState({ jobTags: [], loadingJobTags: false });
		}
	};

	/** Retrieves the total number of job results for each job status based on selected filters */
	getJobCounts = () => {
		const {
			activeGrid,
			filters: {
				dateRange,
				agencyId,
				clientId,
				projectId,
				locationId,
				zoneId,
				jobTagId,
				jobInvoicedType,
				supervisorContactId,
				recurrenceId,
				includeInactive,
				unStaffed,
				deleted,
				sortBy,
				asc,
				prePay,
				pendingApplicants,
				officerStatusFilters,
			},
		} = this.state;

		let {
			filters: { startDate, endDate },
		} = this.state;
		if (dateRange === "custom" && utils.areCustomDatesValid()) {
			startDate =
				utils.isDesktopSafari || utils.isIE
					? startDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: startDate;
			endDate =
				utils.isDesktopSafari || utils.isIE
					? endDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: endDate;
		} else {
			startDate = undefined;
			endDate = undefined;
		}

		const queryParams = {
			dateRange,
			startDate,
			endDate,
			includeInactive,
			deleted,
			sortBy,
			asc,
			pendingApplicants,
			agencyId: agencyId || undefined,
			clientId: clientId || undefined,
			projectId: projectId || undefined,
			locationId: locationId || undefined,
			zoneId: zoneId || undefined,
			jobTagId: jobTagId || undefined,
			jobInvoicedType: jobInvoicedType || undefined,
			supervisorContactId: supervisorContactId || undefined,
			recurrenceId: recurrenceId || undefined,
			unStaffed: activeGrid === "unstaffed" || unStaffed,
			prePay: prePay || undefined,
			officerStatusFilters: officerStatusFilters || undefined,
		};

		if (cancelCounts) cancelCounts();
		JobService.getCounts({
			getCancelToken: c => {
				cancelCounts = c;
			},
			...queryParams,
		})
			.then(({ data }) => {
				cancelCounts = undefined;
				this.setState({ counts: data, loadingCounts: false });
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					this.setState({ loadingCounts: false });
				}
			});
	};

	/**
	 * Retrieves a list of all jobs that match the user's selected filter criteria.
	 * The number of jobs retrieved each time this request is made depends on the number of results the user has chosen to see.
	 */
	getJobs = () => {
		const { pageNumber, filters, activeGrid } = this.state;
		const jobStatus = JOB_STATUSES.find(({ type: jobType }) => jobType === activeGrid);
		let startDate;
		let endDate;
		if (filters.dateRange === "custom" && utils.areCustomDatesValid()) {
			startDate =
				utils.isDesktopSafari || utils.isIE
					? filters.startDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.startDate;
			endDate =
				utils.isDesktopSafari || utils.isIE
					? filters.endDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.endDate;
		}

		// Cleaning up query params so that unecessary fields are not sent as part of the network request
		const queryParams = {
			pageNumber,
			startDate,
			endDate,
			displayCount,
			dateRange: filters.dateRange,
			includeInactive: filters.includeInactive,
			deleted: filters.deleted,
			sortBy: filters.sortBy,
			asc: filters.asc,
			pendingApplicants: filters.pendingApplicants,
			agencyId: filters.agencyId || undefined,
			clientId: filters.clientId || undefined,
			projectId: filters.projectId || undefined,
			zoneId: filters.zoneId || undefined,
			jobTagId: filters.jobTagId || undefined,
			jobInvoicedType: filters.jobInvoicedType || undefined,
			locationId: filters.locationId || undefined,
			supervisorContactId: filters.supervisorContactId || undefined,
			recurrenceId: filters.recurrenceId || undefined,
			unStaffed: activeGrid === "unstaffed" || filters.unStaffed,
			prePay: filters.prePay || undefined,
			status: jobStatus.status,
			officerStatusFilters: filters.officerStatusFilters || undefined,
		};

		if (cancelJobs) cancelJobs();
		JobService.getAll({
			getCancelToken: c => {
				cancelJobs = c;
			},
			...queryParams,
		})
			.then(({ data: { ItemList } }) =>
				this.setState(prevState => ({
					jobs: prevState.pageNumber === 1 ? ItemList : [...prevState.jobs, ...ItemList],
					pageNumber: prevState.pageNumber + 1,
					hasMore: ItemList.length >= 50,
				})),
			)
			.catch(error => {
				if (!axios.isCancel(error)) {
					const { lang } = global;
					this.setState({ pageNumber: 1, hasMore: false });
					utils.notify({
						type: "error",
						message: lang.t("Error loading jobs"),
						timeOut: 1500,
					});
				}
			});
	};

	/** Builds the new URL to be shown in the address bar, eliminating empty and redundant where possible query string values */
	buildNewUrl = () => {
		const { activeGrid, filters, scheduleView } = this.state;
		let startDate;
		let endDate;
		if (filters.dateRange === "custom" && utils.areCustomDatesValid()) {
			startDate =
				utils.isDesktopSafari || utils.isIE
					? filters.startDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.startDate;
			endDate =
				utils.isDesktopSafari || utils.isIE
					? filters.endDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2")
					: filters.endDate;
		}
		const queryParams = {};
		if (filters.dateRange !== 7) queryParams.dateRange = filters.dateRange;
		if (startDate) queryParams.startDate = startDate;
		if (endDate) queryParams.endDate = endDate;
		if (filters.agencyId) queryParams.agencyId = filters.agencyId;
		if (filters.clientId) queryParams.clientId = filters.clientId;
		if (filters.projectId) queryParams.projectId = filters.projectId;
		if (filters.locationId) queryParams.locationId = filters.locationId;
		if (filters.zoneId) queryParams.zoneId = filters.zoneId;
		if (filters.jobTagId) queryParams.jobTagId = filters.jobTagId;
		if (filters.jobInvoicedType) queryParams.jobInvoicedType = filters.jobInvoicedType;
		if (filters.supervisorContactId)
			queryParams.supervisorContactId = filters.supervisorContactId;
		if (filters.recurrenceId) queryParams.recurrenceId = filters.recurrenceId;
		if (filters.includeInactive) queryParams.includeInactive = true;
		if (filters.unStaffed && activeGrid !== "unstaffed") queryParams.unStaffed = true;
		if (filters.deleted) queryParams.deleted = true;
		if (filters.prePay) queryParams.prePay = true;
		if (filters.pendingApplicants) queryParams.pendingApplicants = true;
		if (filters.sortBy !== "StartDateTime") queryParams.sortBy = filters.sortBy;
		if (filters.asc === false) queryParams.asc = false;
		if (filters.officerStatusFilters)
			queryParams.officerStatusFilters = filters.officerStatusFilters;
		if (scheduleView) queryParams.scheduleView = true;

		const queryString = new URLSearchParams(queryParams).toString();
		return `/jobs/list/${activeGrid}${queryString !== "" ? `?${queryString}` : ""}`;
	};

	/**
	 * Updates the job status filter according to what the user clicks on (or selects on mobile) from the `<HeaderGrid>` component
	 * @param {String} type A string value indicating which job status the user would like to filter list results by.
	 * These values come from the `JOB_STATUSES` constant.
	 */
	setActiveGrid = type => {
		this.setState(
			prevState => {
				const { filters } = prevState;
				const resetPendingApplicants = type === "active" || type === "completed";
				if (resetPendingApplicants) filters.pendingApplicants = false;
				if (type === "active") filters.dateRange = 7;
				return {
					pageNumber: 1,
					jobs: [],
					selectedJobs: [],
					hasMore: true,
					activeGrid: type,
					filters,
				};
			},
			() => {
				const { router } = this.props;
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * Searches for an existing job with an Id that is the same as the value entered by the user.
	 * If found, it takes the user to the Job Details page.
	 * @param {String} jobId The Id of the job that the user is searching for
	 */
	onQuickSearch = jobId => {
		const { lang } = global;
		const { router } = this.props;
		const id = parseInt(jobId, 10);
		// 2147483647 is the maximum integer
		// supported by the API, any number greater
		// than this will produce a bad request.
		if (Number.isNaN(id) || id > 2147483647) {
			utils.notify({
				type: "error",
				message: lang.t("Invalid Job Id"),
				timeOut: 2000,
			});
			return;
		}
		this.setState({ searchingForJob: true });
		JobService.getById(jobId)
			.then(() => {
				this.setState({ searchingForJob: false });
				router.push(`/jobs/${jobId}`);
			})
			.catch(() => {
				this.setState({ searchingForJob: false });
				utils.notify({
					type: "error",
					message: lang.t("Job not found"),
					timeOut: 2500,
				});
			});
	};

	toggleMapModal = () => {
		this.setState(prevState => ({ showMapModal: !prevState.showMapModal }));
	};

	toggleScheduleView = () => {
		const { router } = this.props;
		this.setState(
			prevState => ({ scheduleView: !prevState.scheduleView }),
			() => router.push(this.buildNewUrl()),
		);
	};

	/* ***** START: Change handler methods ***** */
	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleAgencyChange = event => {
		const {
			filters: { agencyId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === agencyId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					agencyId: event?.value || "",
					clientId: "",
					projectId: "",
					locationId: "",
				},
				clients: [],
				projects: [],
				locations: [],
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getClients();
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleClientChange = event => {
		const {
			filters: { clientId },
		} = this.state;
		const { user, router } = this.props;
		const isUserNonAdminLEA = user.isLEA() && !user.IsStaffAdmin;
		if (event?.value === clientId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					clientId: event?.value || "",
					supervisorContactId: isUserNonAdminLEA
						? ""
						: prevState.filters.supervisorContactId,
					projectId: "",
					locationId: "",
				},
				projects: [],
				locations: [],
			}),
			() => {
				if (event && !user.isCoordinator()) {
					this.getProjects();
					// FE-1161: Pull a new list of agency supervisors for the selected client for non-staff admin LEAs
					if (isUserNonAdminLEA) this.getSupervisors();
				} else if (event) {
					this.getLocations();
				} else if (isUserNonAdminLEA) {
					// FE-1161: When the client has been cleared, also clear the list of supervisor options until
					// a new client is selected (only for non-staff admin LEA users)
					this.setState({ supervisors: [] });
				}
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleProjectChange = event => {
		const {
			filters: { projectId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === projectId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					projectId: event?.value || "",
					locationId: "",
				},
				locations: [],
			}),
			() => {
				if (event) this.getLocations();
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleLocationChange = event => {
		const {
			filters: { locationId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === locationId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					locationId: event?.value || "",
				},
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleZoneChange = event => {
		const {
			filters: { zoneId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === zoneId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					zoneId: event?.value || "",
				},
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	handleTagChange = event => {
		const {
			filters: { jobTagId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === jobTagId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					jobTagId: event?.value || "",
				},
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	handleJobInvoicedTypeChange = event => {
		const {
			filters: { jobInvoicedType },
		} = this.state;
		const { router } = this.props;
		if (event?.value === jobInvoicedType) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: {
					...prevState.filters,
					jobInvoicedType: event?.value || "",
				},
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleSupervisorChange = event => {
		const {
			filters: { supervisorContactId },
		} = this.state;
		const { router } = this.props;
		if (event?.value === supervisorContactId) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: { ...prevState.filters, supervisorContactId: event?.value || "" },
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleDateRangeChange = event => {
		const { router } = this.props;
		const { value: dateRange } = event;
		// This field is not clearable, so we shouldn't need to check for a null event
		this.setState(
			prevState => ({
				pageNumber: dateRange === "custom" ? prevState.pageNumber : 1,
				jobs: dateRange === "custom" ? prevState.jobs : [],
				selectedJobs: dateRange === "custom" ? prevState.selectedJobs : [],
				hasMore: dateRange === "custom" ? prevState.hasMore : true,
				filters: {
					...prevState.filters,
					dateRange,
					startDate: dateRange === "custom" ? prevState.filters.startDate : "",
					endDate: dateRange === "custom" ? prevState.filters.endDate : "",
				},
			}),
			() => {
				if (dateRange !== "custom") {
					// In case ScrollDetect is already visible in the viewport,
					// make new ones immediately (cancel tokens will cancel existing requests)
					this.getJobs();
					this.getJobCounts();
				}
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * Updates the value of start and end date inputs when the custom date range filter is selected
	 * @param {'startDate'|'endDate'} property The filter property to update
	 * @param {Event} event The HTML event handled by this method
	 */
	handleDateInputChange = (property, { target: { value } }) => {
		const { router } = this.props;
		// For date inputs on iOS, all '/' characters need to be replaced with '-'
		const formattedValue = utils.isIOSDevice ? value.replace(/\//gi, "-") : value;
		this.setState(
			prevState => ({ filters: { ...prevState.filters, [property]: formattedValue } }),
			() => {
				const { filters } = this.state;
				if (utils.areCustomDatesValid(filters.startDate, filters.endDate)) {
					this.setState(
						{
							pageNumber: 1,
							jobs: [],
							selectedJobs: [],
							hasMore: true,
						},
						() => {
							// In case ScrollDetect is already visible in the viewport,
							// make new ones immediately (cancel tokens will cancel existing requests)
							this.getJobs();
							this.getJobCounts();
						},
					);
				}
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * @param {Object} event An object returned from the`ReactSelect` component that contains `value` and `label` properties.
	 * `null` if selection is cleared.
	 */
	handleClockInStatusChange = event => {
		const {
			filters: { officerStatusFilters },
		} = this.state;
		const { router } = this.props;
		if (event?.value === officerStatusFilters) return;

		this.setState(
			prevState => ({
				pageNumber: 1,
				jobs: [],
				selectedJobs: [],
				hasMore: true,
				filters: { ...prevState.filters, officerStatusFilters: event?.value || "" },
			}),
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * Handles updates for all toggle filters
	 * @param {String} name The name of the property to update
	 */
	updateFilters = name => {
		const { activeGrid } = this.state;
		const { router } = this.props;
		const resetPendingApplicants =
			name !== "pendingApplicants" && (activeGrid === "active" || activeGrid === "completed");

		this.setState(
			prevState => {
				const { filters } = prevState;
				if (resetPendingApplicants) filters.pendingApplicants = false;
				filters[name] = !filters[name];
				return {
					pageNumber: 1,
					jobs: [],
					selectedJobs: [],
					hasMore: true,
					filters,
				};
			},
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	/**
	 * Sorts job list records by the given criteria. If that criteria is already applied, this method toggles the value of `asc`.
	 * @param {String} sortBy The criteria by which to sort
	 */
	updateSortCriteria = sortBy => {
		const { router } = this.props;
		this.setState(
			prevState => {
				const { filters } = prevState;
				const { sortBy: prevSortBy, asc: prevAsc } = filters;
				if (prevSortBy !== sortBy) filters.sortBy = sortBy;
				else filters.asc = !prevAsc;

				return {
					pageNumber: 1,
					jobs: [],
					selectedJobs: [],
					hasMore: true,
					filters,
				};
			},
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};

	toggleSelectAllJobs = () => {
		const { jobs, selectedJobs } = this.state;
		const {
			user: { Organization },
		} = this.props;
		const selectableJobs = jobs.filter(
			({ AgencyId, Deleted }) => AgencyId === Organization.Id && !Deleted,
		);
		if (selectedJobs.length === selectableJobs.length) {
			// If the checkbox is unchecked, deselect all selected jobs
			this.setState({ selectedJobs: [] });
		} else {
			// Only select jobs where the managing agency is the logged in user's agency
			this.setState({ selectedJobs: selectableJobs });
		}
		this.validateBulkAssignment(selectableJobs);
	};

	/**
	 * Adds a job to the array of selected jobs. If the job is already part of the array, this method removes it instead.
	 * @param {Number} jobId The ID number of the job
	 */
	updateSelectedJobs = jobId => {
		const {
			selectedJobs: [...selectedJobs],
			jobs,
		} = this.state;
		let jobList = [...selectedJobs];
		if (selectedJobs.some(job => job.Id === jobId)) {
			jobList = jobList.filter(job => job.Id !== jobId);
			this.setState(prevState => ({
				selectedJobs: prevState.selectedJobs.filter(job => job.Id !== jobId),
			}));
		} else {
			jobList.push(jobs.find(job => job.Id === jobId));
			selectedJobs.push(jobs.find(job => job.Id === jobId));
			this.setState({ selectedJobs });
		}
		this.validateBulkAssignment(jobList);
	};

	validateBulkAssignment = jobList => {
		if (jobList.some(job => job.ApplicantsNeeded !== 1 || job.ApplicantsAssigned !== 0)) {
			this.setState({ isBulkAvailable: false });
		} else {
			this.setState({ isBulkAvailable: true });
		}
	};

	/**
	 * Filters the list of jobs shown by only showing those that are part of the selected recurrence group
	 * @param {Number} value The ID number for the selected job recurrence
	 */
	changeRecurrenceFilter = value => {
		const { router } = this.props;
		this.setState(
			prevState => {
				const { filters } = prevState;
				filters.recurrenceId = value;
				return {
					pageNumber: 1,
					jobs: [],
					selectedJobs: [],
					hasMore: true,
					filters,
				};
			},
			() => {
				// In case ScrollDetect is already visible in the viewport,
				// make new ones immediately (cancel tokens will cancel existing requests)
				this.getJobs();
				this.getJobCounts();
				router.push(this.buildNewUrl());
			},
		);
	};
	/* ***** END: Change handler methods ***** */

	/** Opens the appropriate confirmation modal when deleting multiple jobs */
	openBulkDeleteConfirmationModal = () => {
		const { lang } = global;
		const {
			flags: { jobEventAsyncDeletion },
		} = this.props;
		const { jobs, selectedJobs, activeGrid } = this.state;
		const hasRecurringJob = jobs
			.filter(({ Id }) => selectedJobs.some(({ Id: selectedJobId }) => selectedJobId === Id))
			.some(({ JobEventRecurrenceRuleId }) => JobEventRecurrenceRuleId !== null);
		if (hasRecurringJob && activeGrid !== "active") {
			this.setState({ showJobSeriesDeleteModal: true });
		} else {
			let message = lang.t("Are you sure you want to delete this job_");
			message += ` ${lang.t("Any changes, including notes and job assignments, will be lost_")}`;

			if (selectedJobs.length > 1) {
				message = lang.t("Are you sure you want to delete these jobs_");
				message += ` ${lang.t("Any changes, including notes and job assignments, will be lost_")}`;
			}

			if (jobEventAsyncDeletion) {
				message += ` ${lang.t("The system may take a few minutes to complete the deletion")}`;
			}

			this.confirmationModal.current.openModal({
				title: selectedJobs.length > 1 ? lang.t("Delete Jobs") : lang.t("Delete Job"),
				message,
				confirmButton:
					selectedJobs.length > 1
						? lang.t("Yes, delete jobs")
						: lang.t("Yes, delete job"),
				onConfirm: () => this.confirmBulkDeleteJobs(false),
			});
		}
	};

	/**
	 * Confirms the user's intention to delete multiple jobs and updates the UI after completion
	 * @param {Boolean} DeleteAllUpcoming Indicates whether or not all the future jobs in a series should be deleted as well
	 */
	confirmBulkDeleteJobs = DeleteAllUpcoming => {
		const { lang } = global;
		const {
			selectedJobs,
			filters: { deleted },
		} = this.state;
		const data = {
			SelectedJobEvents: selectedJobs.map(({ Id: JobEventId }) => ({
				JobEventId,
				DeleteAllUpcoming,
			})),
		};
		this.setState({ showJobSeriesDeleteModal: false, bulkDeletingJobs: true });
		JobService.deleteMultipleJobs(data)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("dynamic.deleted successfully", {
						item: lang.t(selectedJobs.length <= 1 ? "Job" : "Jobs"),
					}),
					timeOut: 2000,
				});
				this.setState(prevState => {
					const { jobs: prevJobs } = prevState;
					// Filter out all deleted jobs from the jobs list
					let jobs = prevJobs.filter(
						job => !selectedJobs.some(({ Id }) => Id === job.Id),
					);
					// Filter out all jobs that are part of any deleted series that are upcoming (not yet completed)
					selectedJobs.forEach(({ Id, JobEventRecurrenceRuleId }) => {
						if (DeleteAllUpcoming && JobEventRecurrenceRuleId !== null) {
							jobs = jobs.filter(
								job =>
									job.JobEventRecurrenceRuleId !== JobEventRecurrenceRuleId ||
									(job.JobEventRecurrenceRuleId === JobEventRecurrenceRuleId &&
										job.Id < Id),
							);
						}
					});
					// If included deleted jobs in the search results, simply change the Deleted property to `true` for affected jobs instead of removing them
					// from the list
					if (deleted) {
						// Update all deleted jobs from the jobs list
						jobs = prevJobs.map(job => {
							if (selectedJobs.some(({ Id }) => Id === job.Id))
								return { ...job, Deleted: true };
							return job;
						});
						// Update all jobs that are part of any deleted series that are upcoming (not yet completed)
						selectedJobs.forEach(selectedJob => {
							if (
								DeleteAllUpcoming &&
								selectedJob.JobEventRecurrenceRuleId !== null
							) {
								jobs = jobs.map(job => {
									if (
										job.JobEventRecurrenceRuleId ===
											selectedJob.JobEventRecurrenceRuleId &&
										job.Id >= selectedJob.Id
									) {
										return { ...job, Deleted: true };
									}
									return job;
								});
							}
						});
					}
					return { jobs, bulkDeletingJobs: false, selectedJobs: [] };
				});
				this.getJobCounts();
			})
			.catch((error) => {
				this.setState({ bulkDeletingJobs : false });
				const { response } = error
				utils.notify({
					type    : 'error',
					message : selectedJobs.length <= 1 ? lang.t(response.data.Message) : lang.t(response.data.Message),
					timeOut : 2000,
				});
			});
	};

	/**
	 * Opens a modal asking if the entire job series should be restored if the selected job is part of one. Otherwise, the job is restored immediately.
	 * @param {Object} job A data object representing the job to restore
	 * @returns {(event:Event) => void}
	 */
	restoreJob = job => event => {
		event.preventDefault();
		const { JobEventRecurrenceRuleId } = job;

		if (JobEventRecurrenceRuleId && JobEventRecurrenceRuleId !== null)
			this.setState({ jobToRestoreSeries: job });
		else this.handleRestore(false, job);
	};

	/**
	 * Makes a request to restore a job (and others in the series, if chosen) and updates the jobs list in place
	 * @param {Boolean} restoreAll Whether all jobs in a series should be restored or not
	 * @param {Object} job A data object representing the job to restore
	 */
	handleRestore = (restoreAll, job) => {
		const { lang } = global;
		const { Id: id, JobEventRecurrenceRuleId } = job;
		JobService.restore({ id, restoreAll })
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Job restored successfully"),
					title: "Success",
				});
				// Update this job (if part of a series, all upcoming jobs in this series accordingly)
				this.setState(prevState => {
					let { jobs } = prevState;
					jobs = jobs.map(j => {
						if (
							j.Id === id ||
							(restoreAll && j.JobEventRecurrenceRuleId === JobEventRecurrenceRuleId)
						)
							return { ...j, Deleted: false };
						return j;
					});
					return { jobs, jobToRestoreSeries: undefined };
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error restoring Job"),
				});
			});
	};

	/**
	 * Navigates to the Job Details page when the user clicks on a row. Navigation only occurs if a
	 * button, checkbox, label, or link has not been clicked.
	 * @param {Number} jobEventId The Id for the job to retrieve details for
	 */
	navigateToJobDetails = jobEventId => event => {
		const { router } = this.props;
		const {
			target: { type, localName },
		} = event;

		if (type !== "button" && type !== "checkbox" && localName !== "label" && localName !== "a")
			router.push(`/jobs/${jobEventId}`);
	};

	/**
	 * Render a job's posted status based on values destructured from the `jobEvent` object
	 * @param {Object} jobEvent the job to show the posted status for
	 */
	renderPostedStatus = jobEvent => {
		const { lang } = global;
		const {
			user: { TimeZoneId },
			user,
		} = this.props;
		const { PostAtDateTime, Posted, PostedDate, CreateDateUTC, PostedType, PostedGroupName } =
			jobEvent;

		let status = "";
		let date = "";
		const postDate = new Date(`${PostAtDateTime || PostedDate}Z`).getTime();
		const now = new Date().getTime();

		if (
			Posted &&
			[
				JOB_POSTED_TYPES.ALL,
				JOB_POSTED_TYPES.ALL_MINUTES_CONSTRAINT,
				JOB_POSTED_TYPES.ALL_WEEKDAY_CONSTRAINT,
			].includes(PostedType)
		) {
			status = now > postDate ? lang.t("Posted") : lang.t("Will be posted on");
			date = utils.formatDate(
				new Date(postDate),
				"en-US",
				TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short",
			);
		} else if (Posted && PostedType === JOB_POSTED_TYPES.ALL_GROUPS) {
			status =
				now > postDate
					? lang.t("Posted to All Officer Groups")
					: lang.t("Will be posted to All Officer Groups on");
		} else if (Posted && PostedType === JOB_POSTED_TYPES.GROUPS) {
			status =
				now > postDate
					? lang.t("dynamic.Posted to group", { PostedGroupName })
					: lang.t("dynamic.Will be posted to group", { PostedGroupName });
		}

		if (Posted) {
			date = utils.formatDate(
				new Date(postDate),
				"en-US",
				TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short",
			);
		} else {
			status = "Created";
			date = utils.formatDate(
				new Date(`${CreateDateUTC}Z`),
				"en-US",
				TimeZoneId,
				user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short",
			);
		}

		return (
			<Fragment>
				<br className="hidden-xs" />
				<i
					className={`glyphicon ${Posted ? "glyphicon-eye-open text-success" : "glyphicon-eye-close text-danger"}`}
					title={lang.t(Posted ? "Job has been posted" : "Job has not been posted")}
				/>
				<span className="posting-info">
					{status} {date}
				</span>
			</Fragment>
		);
	};

	/**
	 * Render assigned officers and job's current staffing status. For jobs that only require one officer,
	 * the officer's contact details are also presented to the user
	 * @param {Object} jobEvent the job to show assigned officers for
	 */
	renderAssignedOfficers = jobEvent => {
		const { lang } = global;
		const { Jobs, ApplicantsAssigned, ApplicantsNeeded, AverageRate } = jobEvent;

		const assignedOfficers = Jobs.filter(item => item.AssignedOfficers.length > 0)
			.map(item => item.AssignedOfficers)
			.reduce((acc, item) => [...acc, ...item], [])
			.map(item => ({
				...item.OfficerProfile,
				OfficerName: `${item.OfficerProfile.FirstName} ${item.OfficerProfile.LastName}`,
				OfficerStatus: item.OfficerStatus,
				UserId: item.UserId,
			}));

		const externalOfficers = Jobs.filter(item => item.ExternalOfficers.length > 0)
			.map(item => item.ExternalOfficers)
			.reduce((acc, item) => [...acc, ...item], [])
			.map(item => ({ ...item, isExternal: true }));

		const getStatusDescription = officer => {
			const officerStatusType = officer.OfficerStatus || 0;
			const status = Object.values(OFFICER_STATUSES).find(
				officerStatus => officerStatus.type === officerStatusType,
			);
			return <span className={`label label-${status.color}`}>{status.description}</span>;
		};

		const officers = [...assignedOfficers, ...externalOfficers];
		const firstThreeOfficers = officers.length > 3 ? officers.slice(0, 3) : officers;
		const firstOfficer = officers[0] || {};
		const _doItHavePayCodeAdded = utils.doItHavePayCodeAdded(Jobs);

		return (
			<Choose>
				<When condition={ApplicantsAssigned === 1 && ApplicantsNeeded === 1}>
					<div className="single-officer row">
						<div className="col-sm-12">
							<Image
								className="officer-image img-circle"
								src={firstOfficer.ContactPhotoUrl || ""}
								fallbackSrc="avatar"
							/>
							<div className="officer-info">
								<strong>{firstOfficer.OfficerName || ""}</strong>
								<If condition={firstOfficer.isExternal}>
									<br />
									<em>{lang.t("Non-RollKall Officer")}</em>
								</If>
								<br />
								<If condition={!_doItHavePayCodeAdded}>
									{lang.t("Rate")}: {utils.currencyFormatter(AverageRate, false)}
									{lang.t("_hour")}
								</If>
							</div>
						</div>
					</div>
					<If condition={!firstOfficer.isExternal}>
						<div className="officer-contact truncate">
							<i className="glyphicon glyphicon-earphone" />
							{firstOfficer.CellPhone
								? utils.formatPhoneNumber(firstOfficer.CellPhone)
								: lang.t("Not Available")}
							<br />
							<i className="glyphicon glyphicon-envelope" />
							<span title={firstOfficer.Email || lang.t("Not Available")}>
								{firstOfficer.Email || lang.t("Not Available")}
							</span>
						</div>
					</If>
					<span className="label label-success">{lang.t("Staffed")}</span>
					<If
						condition={
							!firstOfficer.isExternal &&
							firstOfficer.OfficerStatus !== OFFICER_STATUSES.none.type
						}
					>
						{getStatusDescription(firstOfficer)}
					</If>
				</When>
				<When condition={ApplicantsAssigned > 0 && ApplicantsNeeded > 1}>
					<div className="multi-officer">
						<For
							each="officer"
							of={firstThreeOfficers}
						>
							<Image
								key={`officer-thumb-${officer.isExternal ? `e-${officer.Id}` : officer.UserId}`}
								className="officer-image img-circle"
								src={officer.ContactPhotoUrl || ""}
								fallbackSrc="avatar"
							/>
						</For>
						<If condition={officers.length > 3}>
							<div className="extra-count">{`+${officers.length - 3}`}</div>
						</If>
					</div>
				</When>
			</Choose>
		);
	};

	/**
	 * Tells the user approximately how much time is left before an upcoming job is scheduled to start.
	 * The lowest units returned are minutes and the highest units returned are days.
	 * @param {String} startDateTime The date and time that a job is scheduled to start
	 * @return {String} A humanized line of text indicating the amount of time before a job is scheduled to start
	 */
	timeToJobStart = startDateTime => {
		const { lang } = global;
		const jobStart = new Date(`${startDateTime}Z`).getTime();
		const now = new Date().getTime();
		const minutesDiff = (jobStart - now) / 1000 / 60;
		const hoursDiff = minutesDiff / 60;

		if (minutesDiff < 1) return lang.t("Starting soon");
		if (Math.round(minutesDiff) <= 60) {
			// eslint-disable-next-line camelcase
			return lang.t("dynamic.Starts in minutes", { smart_count: Math.round(minutesDiff) });
		}
		if (Math.round(minutesDiff) > 60 && Math.floor(hoursDiff < 24)) {
			// eslint-disable-next-line camelcase
			return lang.t("dynamic.Starts in hours", { smart_count: Math.round(hoursDiff) });
		}
		// eslint-disable-next-line camelcase
		return lang.t("dynamic.Starts in days", { smart_count: Math.round(hoursDiff / 24) });
	};

	/**
	 * Opens the bulk assignment modal to allow users to assign an officer to multiple jobs
	 * @param {Object} jobEvent The jobs that the user would like to assign an officer for
	 * @param {Number} defaultPosition The ID number for the position to show upon opening the modal
	 */
	openBulkAssignModal = (jobEvent, defaultPosition) => {
		this.setState({
			bulkAssignModal: {
				show: true,
				isActiveJob: jobEvent.IsActive,
				positions: jobEvent.Jobs,
				defaultPosition,
				recurrenceRule: jobEvent.JobEventRecurrenceRule,
				isPrepayJob: jobEvent.RequirePrepayment,
				isRKPayJob: jobEvent.IsRKPay,
			},
		});
	};

	/**
	 * Closes the manual assignment modal and informs us if any data related to job assignments was updated
	 * @param {Boolean} assignmentsChanged Indicates whether or not the list or multi-position modal data needs to be updated
	 */
	closeBulkAssignModal = assignmentsChanged => {
		this.setState(
			prevState => ({
				bulkAssignModal: { ...prevState.bulkAssignModal, show: false },
			}),
			() => {
				const { multiPositionModal } = this.state;
				if (assignmentsChanged && !multiPositionModal.show) {
					this.updateExistingItems();
				} else if (assignmentsChanged) {
					// Patch update the assigned officers for each position if any data was updated from the manual assignment modal.
					// We must call the API for each position's officers since the JobDetails endpoint does not return all the required
					// values to display position info in the multi-position modal
					const { job } = multiPositionModal;
					const promises = job.Jobs.map(position =>
						JobService.getAssignedOfficersByPositionId(position.Id)
							.then(({ data: { AssignedOfficers, ExternalOfficers } }) => ({
								...position,
								AssignedOfficers,
								ExternalOfficers,
								ApplicantsAssigned:
									AssignedOfficers.length + ExternalOfficers.length,
							}))
							.catch(() => position),
					);
					Promise.all(promises).then(Jobs => {
						// Jobs is an array of objects with up-to-date assigned officers for each position, so we can update the
						// Jobs property of multiPositionModal.job with this new value
						this.setState(prevState => ({
							multiPositionModal: {
								...prevState.multiPositionModal,
								assignmentsUpdated: true,
								job: { ...prevState.multiPositionModal.job, Jobs },
							},
						}));
					});
				}
			},
		);
	};

	/**
	 * Opens the manual assignment modal to allow users to assign/unassign officers to a particular job
	 * @param {Object} jobEvent The job that the user would like to assign officers for
	 * @param {Number} defaultPosition The ID number for the position to show upon opening the modal
	 */
	openManualAssignModal = (jobEvent, defaultPosition) => {
		this.setState({
			manualAssignModal: {
				show: true,
				isActiveJob: jobEvent.IsActive,
				positions: jobEvent.Jobs,
				defaultPosition,
				recurrenceRule: jobEvent.JobEventRecurrenceRule,
				isPrepayJob: jobEvent.RequirePrepayment,
				isRKPayJob: jobEvent.IsRKPay,
			},
		});
	};

	/**
	 * Closes the manual assignment modal and informs us if any data related to job assignments was updated
	 * @param {Boolean} assignmentsChanged Indicates whether or not the list or multi-position modal data needs to be updated
	 */
	closeManualAssignModal = assignmentsChanged => {
		this.setState(
			prevState => ({
				manualAssignModal: { ...prevState.manualAssignModal, show: false },
			}),
			() => {
				const { multiPositionModal } = this.state;
				if (assignmentsChanged && !multiPositionModal.show) {
					this.updateExistingItems();
				} else if (assignmentsChanged) {
					// Patch update the assigned officers for each position if any data was updated from the manual assignment modal.
					// We must call the API for each position's officers since the JobDetails endpoint does not return all the required
					// values to display position info in the multi-position modal
					const { job } = multiPositionModal;
					const promises = job.Jobs.map(position =>
						JobService.getAssignedOfficersByPositionId(position.Id)
							.then(({ data: { AssignedOfficers, ExternalOfficers } }) => ({
								...position,
								AssignedOfficers,
								ExternalOfficers,
								ApplicantsAssigned:
									AssignedOfficers.length + ExternalOfficers.length,
							}))
							.catch(() => position),
					);
					Promise.all(promises).then(Jobs => {
						// Jobs is an array of objects with up-to-date assigned officers for each position, so we can update the
						// Jobs property of multiPositionModal.job with this new value
						this.setState(prevState => ({
							multiPositionModal: {
								...prevState.multiPositionModal,
								assignmentsUpdated: true,
								job: { ...prevState.multiPositionModal.job, Jobs },
							},
						}));
					});
				}
			},
		);
	};

	finishBulkAssignment = () => {
		this.setState({
			selectedJobs: [],
		});
		this.updateFilters("refresh");
	};

	/** Closes the multi-position modal and determines if a list update is necessary after doing so */
	closeMultiPositionModal = () => {
		const {
			multiPositionModal: { assignmentsUpdated },
		} = this.state;
		this.setState({ multiPositionModal: { ...this.initialMultiPositionModal } }, () => {
			if (assignmentsUpdated) this.updateExistingItems();
		});
	};

	/** Retrieves updated job event details after successfully posting one or more jobs */
	postJobSuccessCallback = () => {
		const { selectedJobs } = this.state;
		// A simple in-place update is not possible due to the new information required to show posted status
		// In order to do this without recalling the entire list of jobs from page 1, we need to get details for each affected job
		const postedJobDetails = selectedJobs.map(
			({ Id }) =>
				new Promise(resolve =>
					// eslint-disable-next-line no-promise-executor-return
					JobService.getById(Id)
						.then(({ data }) => resolve(data))
						.catch(() => resolve({})),
				),
		);
		Promise.all(postedJobDetails)
			.then(updatedJobs => {
				this.setState(prevState => {
					let { jobs } = prevState;
					jobs = jobs.map(job => {
						// If the job's Id is one that matches an updated job, change the relevant properties in state to reflect the correct
						// posted status
						const updatedJob = updatedJobs.find(({ Id }) => Id === job.Id);
						if (updatedJob) {
							const {
								PostAtDateTime,
								Posted,
								PostedDate,
								CreateDateUTC,
								PostedType,
								PostedGroupName,
							} = updatedJob;
							return {
								...job,
								PostAtDateTime,
								Posted,
								PostedDate,
								CreateDateUTC,
								PostedType,
								PostedGroupName,
							};
						}
						return job;
					});
					return { jobs, selectedJobs: [] };
				});
			})
			.catch(() =>
				utils.notify({
					type: "warning",
					message:
						"Jobs posted successfully, but the page could not be updated. Please refresh to view latest changes.",
					timeOut: 2500,
				}),
			);
	};

	/**
	 * Opens a confirmation modal where the user is informed about the potential impact of deleting a job.
	 * @param {Object} job The job that the user has chosen to delete
	 */
	openDeleteConfirmationModal = job => {
		const { lang } = global;
		const { Id: jobId, JobEventRecurrenceRuleId } = job;
		// When a recurring job is chosen to be deleted, `<JobSeriesDeleteModal>` is shown so that the user can choose which instance(s) of the job to delete
		// For non-recurring jobs, a simple confirmation modal is opened so that the user can confirm that they actually want to delete the selected job.
		if (JobEventRecurrenceRuleId) {
			this.setState({ showJobSeriesDeleteModal: true, deletingJob: jobId });
		} else {
			let message = lang.t("Are you sure you want to delete this job_");
			message += ` ${lang.t("Any changes, including notes and job assignments, will be lost_")}`;
			this.setState({ deletingJob: jobId });
			this.confirmationModal.current.openModal({
				title: lang.t("Delete Job"),
				message,
				confirmButton: lang.t("Yes, delete job"),
				onConfirm: () => this.confirmDeleteJob(false),
			});
		}
	};

	/**
	 * Deletes a single job after a user has confirmed that the job should be deleted.
	 * This method is used for both recurring and non-recurring jobs.
	 * @param {Boolean} deleteAllUpcoming Indicates whether all upcoming jobs in a series should be deleting along with the selected job.
	 * This is always false for jobs that do not have a recurrence rule associated with them.
	 */
	confirmDeleteJob = deleteAllUpcoming => {
		const { lang } = global;
		const {
			filters: { deleted },
			deletingJob,
			selectedJobs,
		} = this.state;
		const jobEventId = deletingJob || selectedJobs[0]?.Id;
		this.setState({ showJobSeriesDeleteModal: false });
		JobService.deleteJob({}, { deleteAllUpcoming, jobEventId, deleteReason: "" })
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("dynamic.deleted successfully", { item: lang.t("Job") }),
					timeOut: 1500,
				});
				this.setState(prevState => {
					const { jobs: prevJobs } = prevState;
					const recurrenceRuleId = (prevJobs.find(({ Id }) => Id === jobEventId) || {})
						.JobEventRecurrenceRuleId;
					let jobs = prevJobs.filter(job => {
						// If all upcoming instances of a job were deleted, remove all future instances of that job from the list
						if (deleteAllUpcoming)
							return (
								job.JobEventRecurrenceRuleId !== recurrenceRuleId ||
								job.Id < jobEventId
							);
						return job.Id !== jobEventId;
					});
					// If included deleted jobs in the search results, simply change the Deleted property to `true` for affected jobs instead of removing them
					// from the list
					if (deleted) {
						jobs = prevJobs.map(job => {
							if (
								job.Id === jobEventId ||
								(deleteAllUpcoming &&
									job.JobEventRecurrenceRuleId === recurrenceRuleId &&
									job.Id >= jobEventId)
							) {
								return { ...job, Deleted: true };
							}
							return job;
						});
					}
					return { jobs, deletingJob: undefined, selectedJobs: [] };
				});
				this.getJobCounts();
			})
			.catch((error) => {
				this.setState({ deletingJob : undefined });
				const { response } = error;
				utils.notify({
					type    : 'error',
					message : lang.t(response.data.Message),
					timeOut : 2000,
				});
			});
	};

	/**
	 * Opens the the multiple position modal so that users can see a positional breakdown of rates, assigned officers, requirements, etc.
	 * @param {Object} job The job that the user would like to assign officers for
	 */
	openMultiPositionModal = job => {
		this.setState({ multiPositionModal: { show: true, job } });
	};

	onClickTab = ({ tabNumber, url }) => {
		const {
			router: { push },
		} = this.props;
		const thisTab = JOBS_SUB_MENU.find(tab => tab.type === "list");
		if (tabNumber !== thisTab.tabNumber) push(url);
	};

	createEstimateFromJobs = () => {
		const { selectedJobs } = this.state;
		const { router } = this.props;
		const clientId = [...new Set(selectedJobs.map(job => job.ClientId))][0];
		const jobEventIds = selectedJobs.map(job => job.Id);
		this.setState(
			{
				selectedJobs: [],
				showAddToEstimateModal: false,
			},
			() => {
				router.push({
					pathname: "/payments/manualinvoice",
					query: { estimate: true, clientId, jobs: jobEventIds.join(",") },
				});
			},
		);
	};

	handleAddToEstimate = (queryParams) => {
		const { router } = this.props;
		this.setState(
			{
				selectedJobs: [],
				showAddToEstimateModal: false,
			},
			() => {
				router.push({ pathname: "/payments/manualinvoice", query: queryParams });
			}
		)
	}

	renderDateRange = job => {
		const { user } = this.props;
		const startDateF = utils.formatDate(
			new Date(`${job.StartDateTime}Z`),
			"en-US",
			user.TimeZoneId,
			"w-long-no-year",
		);
		const endDateF = utils.formatDate(
			new Date(`${job.EndDateTime}Z`),
			"en-US",
			user.TimeZoneId,
			"w-long-no-year",
		);

		return (
			<>
				{startDateF}
				<If
					condition={
						job.JobEventTypeId === FORM_JOB_TYPES.EVENT.value && startDateF !== endDateF
					}
				>
					&nbsp;-
					<br />
					{endDateF}
				</If>
			</>
		);
	};

	mapJobToJobInvoicedTypeId = (job) => {
		if (job.JobInvoicedTypeId) return job.JobInvoicedTypeId;

		return job.IsRKPay ? JOB_INVOICED_TYPES.OFFICER_INVOICING : JOB_INVOICED_TYPES.AGENCY_INVOICING;
	}

	render() {
		const { lang } = global;
		const {
			showFilters,
			loadingCounts,
			searchingForJob,
			counts,
			hasMore,
			jobs,
			selectedJobs,
			activeGrid,
			loadingAgencies,
			agencies,
			loadingClients,
			clients,
			loadingProjects,
			projects,
			loadingZones,
			zones,
			loadingJobTags,
			jobTags,
			loadingLocations,
			locations,
			loadingSupervisors,
			supervisors,
			filters,
			multiPositionModal,
			manualAssignModal,
			bulkAssignModal,
			showPostJobModal,
			showJobSeriesDeleteModal,
			jobToRestoreSeries,
			deletingJob,
			bulkDeletingJobs,
			showMapModal,
			scheduleView,
			isBulkAvailable,
			jurisdictionPaymentRules,
			showAddToEstimateModal,
		} = this.state;

		const {
			router,
			user,
			user: {
				Organization: {
					PayCodesEnabled,
					NonRKPayPaymentsEnabled,
					NonRKPayInvoicingEnabled,
				},
			},
			flags: { jobListAddToEstimateButtonEnabled }
		} = this.props;
		let canDisplayRibbon = false;
		if (
			user.isSuperAdmin() ||
			user.isCoordinator() ||
			user.isAgencyAdmin() ||
			(user.isLEA() && !jurisdictionPaymentRules?.transferPaymentToJurisdiction)
		) {
			canDisplayRibbon = true;
		}
		const isPrepayEnabled = user.Features.some(f => f.toLowerCase() === "prepay");
		const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === "invoicingv3");
		const isOfficerInvoicingV3 = user.Features.some(f => f.toLowerCase() === "officerinvoicingv3");
		const selectedJobClients = [...new Set(selectedJobs.map(({ ClientId }) => ClientId))];
		const selectableJobCount = jobs.filter(
			({ AgencyId, Deleted }) => AgencyId === user.Organization.Id && !Deleted,
		).length;

		let jobInvoicedTypes = [];

		if (user.isSuperAdmin()) {
			jobInvoicedTypes = [
				{ value: JOB_INVOICED_TYPES.OFFICER_INVOICING, label: lang.t("Officer Invoicing") },
				{ value: JOB_INVOICED_TYPES.AGENCY_INVOICING, label: lang.t("Agency Invoicing") },
				{ value: JOB_INVOICED_TYPES.SCHEDULE_ONLY, label: lang.t("Schedule Only") },
			];
		} else if (user.isLEA() || user.isCoordinator()) {
			if (isInvoicingV3 || NonRKPayPaymentsEnabled || NonRKPayInvoicingEnabled) {
				jobInvoicedTypes = [
					{
						value: JOB_INVOICED_TYPES.OFFICER_INVOICING,
						label: lang.t("Officer Invoicing"),
					},
					{
						value: JOB_INVOICED_TYPES.AGENCY_INVOICING,
						label: lang.t("Agency Invoicing"),
					},
					{ value: JOB_INVOICED_TYPES.SCHEDULE_ONLY, label: lang.t("Schedule Only") },
				];
			} else {
				jobInvoicedTypes = [
					{
						value: JOB_INVOICED_TYPES.OFFICER_INVOICING,
						label: lang.t("Officer Invoicing"),
					},
					{ value: JOB_INVOICED_TYPES.SCHEDULE_ONLY, label: lang.t("Schedule Only") },
				];
			}
		} else if (user.isAgencyAdmin()) {
			jobInvoicedTypes = [
				{ value: JOB_INVOICED_TYPES.OFFICER_INVOICING, label: lang.t("Officer Invoicing") },
				{ value: JOB_INVOICED_TYPES.SCHEDULE_ONLY, label: lang.t("Schedule Only") },
			];
		}

		let dateRangeOptions = [
			{
				value: 1,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 24 ${lang.t("Hours")}`,
			},
			{
				value: 2,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 48 ${lang.t("Hours")}`,
			},
			{
				value: 7,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 7 ${lang.t("Days")}`,
			},
			{
				value: 14,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 14 ${lang.t("Days")}`,
			},
			{
				value: 30,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 30 ${lang.t("Days")}`,
			},
			{
				value: 90,
				label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 90 ${lang.t("Days")}`,
			},
			{ value: "custom", label: lang.t("Custom Date Range") },
		];

		if (user.Organization.CanExceedRecurrentJobCreation) {
			dateRangeOptions = [
				{
					value: 1,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 24 ${lang.t("Hours")}`,
				},
				{
					value: 2,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 48 ${lang.t("Hours")}`,
				},
				{
					value: 7,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 7 ${lang.t("Days")}`,
				},
				{
					value: 14,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 14 ${lang.t("Days")}`,
				},
				{
					value: 30,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 30 ${lang.t("Days")}`,
				},
				{
					value: 90,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 90 ${lang.t("Days")}`,
				},
				{
					value: 180,
					label: `${activeGrid === "completed" ? lang.t("Last") : lang.t("Next")} 180 ${lang.t("Days")}`,
				},
				{ value: "custom", label: lang.t("Custom Date Range") },
			];
		}
		const timecardExceptions = [
			{ value: 1, label: lang.t("No Clock-In") },
			{ value: 2, label: lang.t("Late Clock-In") },
			{ value: 3, label: lang.t("Automatic Clock-Out") },
			{ value: 4, label: lang.t("Early Clock-Out") },
		];

		const areSelectedJobsWithoutEstimate = selectedJobs.every(job => !job.HasNonRKPayInvoiceEstimate);
		const areselectedJobsNotSchedulingOnly = selectedJobs.every(job => job.JobInvoicedTypeId !== JOB_INVOICED_TYPES.SCHEDULE_ONLY);
		const selectedJobsConsistencyInvoicingType =
			selectedJobs.every(job => this.mapJobToJobInvoicedTypeId(job) === JOB_INVOICED_TYPES.OFFICER_INVOICING) ||
			selectedJobs.every(job => this.mapJobToJobInvoicedTypeId(job)=== JOB_INVOICED_TYPES.AGENCY_INVOICING);

		const isAnyJobClientEnforceV2 = selectedJobs.some(job => job.ClientEnforceV2NonRKPayInvoicing);
		const isAnyOfficerInvoicing = selectedJobs.some(job => this.mapJobToJobInvoicedTypeId(job) === JOB_INVOICED_TYPES.OFFICER_INVOICING);
		// Officer Invoicing is allowed in NonRKPay only if client does not enforce V2
		const validClientEnforceInvoicing = (!isAnyJobClientEnforceV2 || !isAnyOfficerInvoicing);

		const canShowAddToEstimate =
			isInvoicingV3 &&
			(
				isOfficerInvoicingV3 ||
				!isAnyOfficerInvoicing
			) &&
			areSelectedJobsWithoutEstimate &&
			areselectedJobsNotSchedulingOnly &&
			selectedJobsConsistencyInvoicingType &&
			validClientEnforceInvoicing &&
			activeGrid !== "active" &&
			selectedJobClients.length === 1;

		return (
			<Fragment>
				<TabMenu
					tabs={JOBS_SUB_MENU}
					activeTab={JOBS_SUB_MENU.find(tab => tab.type === "list").tabNumber}
					onClickTab={this.onClickTab}
					user={user}
				/>
				<div
					className="container"
					id="jobs-list"
					data-test-id="jobs__list"
				>
					<div className="row row-title">
						<div className="col-xs-6 col-sm-10">
							<h2>
								{lang.t("Jobs")}
								<If condition={filters.recurrenceId}>
									&nbsp;/ {lang.t("Recurrence")} {filters.recurrenceId}
									<button
										type="button"
										className="btn btn-link"
										onClick={() => this.changeRecurrenceFilter("")}
										data-test-id="jobs__recurrence-filter-clear-btn"
									>
										<span className="badge">&times;</span>
									</button>
								</If>
							</h2>
						</div>
						<If
							condition={!user.isSuperAdmin() && !user.isClient() && !user.IsViewOnly}
						>
							<div className="col-xs-6 col-sm-2">
								<button
									type="button"
									id="add-job"
									className="btn btn-primary btn-block"
									onClick={() => router.push("/jobs/add")}
									data-test-id="jobs__add-job-btn"
								>
									+ {lang.t("New Job")}
								</button>
							</div>
						</If>
					</div>
					<HeaderGrid
						gridOptions={JOB_STATUSES}
						loadingCounts={loadingCounts}
						counts={counts}
						activeGrid={activeGrid}
						setActive={this.setActiveGrid}
					/>
					<div className="row form-group">
						<div className="col-sm-3 col-sm-offset-9">
							<SearchField
								placeholder={lang.t("dynamic.Go to", { place: lang.t("Job #") })}
								inputGroupClass="go-to-job"
								onSearch={this.onQuickSearch}
								iconClass={`glyphicon ${searchingForJob ? "glyphicon-repeat rkf-spin rkf-fw" : "glyphicon-arrow-right"}`}
								dataTestId="jobs__go-to-job-search"
							/>
						</div>
					</div>
					<div className="job-filters">
						<div className="row">
							<div className="col-xs-5 col-sm-9">
								<h3 className="hidden-xs">{lang.t("Filters")}</h3>
								<button
									type="button"
									className="btn btn-link text-left filter-toggle visible-xs-inline"
									data-test-id="jobs__filter-toggle-btn"
									onClick={() =>
										this.setState(prevState => ({
											showFilters: !prevState.showFilters,
										}))
									}
								>
									<span className="h4">{lang.t("Filters")}</span>
									<i
										className={`text-primary glyphicon glyphicon-chevron-${showFilters ? "up" : "down"}`}
									/>
								</button>
							</div>
							<div className="col-xs-7 col-sm-3 text-right">
								<div className="btn-group">
									<button
										type="button"
										className={`btn ${scheduleView ? "btn-primary" : "btn-default"}`}
										data-test-id="jobs__schedule-view-btn"
										onClick={() => this.toggleScheduleView()}
									>
										{lang.t("Schedule")}
									</button>
									<button
										type="button"
										className="btn btn-default"
										data-test-id="jobs__map-view-btn"
										onClick={() => this.toggleMapModal()}
									>
										{lang.t("Map")}
									</button>
								</div>
							</div>
						</div>
						<div className={`row ${showFilters ? "" : "hidden-xs"}`}>
							<If condition={user.isSuperAdmin() || user.isLEA()}>
								<div className="col-sm-3 form-group">
									<label htmlFor="select-agency">{lang.t("Agency")}</label>
									<ReactSelect
										id="select-agency"
										name="select-agency"
										value={parseInt(filters.agencyId, 10)}
										onChange={this.handleAgencyChange}
										options={agencies}
										isLoading={loadingAgencies}
										isClearable
										dataTestId="jobs__select-agency"
									/>
								</div>
							</If>
							<If condition={!user.isClient()}>
								<div className="col-sm-3 form-group">
									<label htmlFor="select-client">{lang.t("Client")}</label>
									<ReactSelect
										id="select-client"
										name="select-client"
										value={parseInt(filters.clientId, 10)}
										onChange={this.handleClientChange}
										options={clients}
										isLoading={loadingClients}
										isClearable
										dataTestId="jobs__select-client"
									/>
								</div>
							</If>
							<If condition={!user.isCoordinator()}>
								<div className="col-sm-3 form-group">
									<label htmlFor="select-project">{lang.t("Project")}</label>
									<ReactSelect
										id="select-project"
										name="select-project"
										value={parseInt(filters.projectId, 10)}
										onChange={this.handleProjectChange}
										options={projects}
										isLoading={loadingProjects}
										isClearable
										dataTestId="jobs__select-project"
									/>
								</div>
							</If>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-location">{lang.t("Location")}</label>
								<ReactSelect
									id="select-location"
									name="select-location"
									value={parseInt(filters.locationId, 10)}
									onChange={this.handleLocationChange}
									options={locations}
									isLoading={loadingLocations}
									isClearable
									dataTestId="jobs__select-location"
								/>
							</div>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-supervisor">{lang.t("Supervisor")}</label>
								<ReactSelect
									id="select-supervisor"
									name="select-supervisor"
									value={parseInt(filters.supervisorContactId, 10)}
									onChange={this.handleSupervisorChange}
									options={supervisors}
									isLoading={loadingSupervisors}
									isClearable
									dataTestId="jobs__select-supervisor"
								/>
							</div>
							<If condition={activeGrid === "active" || activeGrid === "completed"}>
								<div className="col-sm-3 form-group">
									<label htmlFor="officerStatusFilters">
										{lang.t("Timecard Exception")}
									</label>
									<ReactSelect
										id="officerStatusFilters"
										name="officerStatusFilters"
										value={parseInt(filters.officerStatusFilters, 10)}
										onChange={this.handleClockInStatusChange}
										options={timecardExceptions}
										isClearable
										dataTestId="jobs__select-timecard-exception"
									/>
								</div>
							</If>
							<If condition={activeGrid !== "active"}>
								<div className="col-sm-3 form-group">
									<label htmlFor="date-range">{lang.t("Date Range")}</label>
									<ReactSelect
										id="date-range"
										name="date-range"
										value={filters.dateRange}
										onChange={this.handleDateRangeChange}
										options={dateRangeOptions}
										dataTestId="jobs__select-date-range"
									/>
								</div>
							</If>
							<If condition={filters.dateRange === "custom"}>
								<div className="col-sm-3 form-group">
									<label htmlFor="dateRangeStart">{lang.t("Start Date")}</label>
									<Choose>
										<When condition={utils.isDesktopSafari || utils.isIE}>
											<MaskedInput
												name="dateRangeStart"
												id="dateRangeStart"
												type="text"
												mask={this.dateMask}
												className="form-control"
												placeholder="mm/dd/yyyy"
												value={filters.startDate}
												onChange={event =>
													this.handleDateInputChange("startDate", event)
												}
											/>
										</When>
										<Otherwise>
											<input
												name="dateRangeStart"
												id="dateRangeStart"
												data-test-id="jobs__date-range-start"
												type="date"
												className="form-control"
												min={
													activeGrid === "completed"
														? undefined
														: utils.formatDate(
																undefined,
																undefined,
																undefined,
																"noslash",
															)
												}
												value={filters.startDate}
												onChange={event =>
													this.handleDateInputChange("startDate", event)
												}
											/>
										</Otherwise>
									</Choose>
								</div>
								<div className="col-sm-3 form-group">
									<label htmlFor="dateRangeEnd">{lang.t("End Date")}</label>
									<Choose>
										<When condition={utils.isDesktopSafari || utils.isIE}>
											<MaskedInput
												name="dateRangeEnd"
												id="dateRangeEnd"
												type="text"
												mask={this.dateMask}
												className="form-control"
												placeholder="mm/dd/yyyy"
												value={filters.endDate}
												onChange={event =>
													this.handleDateInputChange("endDate", event)
												}
											/>
										</When>
										<Otherwise>
											<input
												name="dateRangeEnd"
												id="dateRangeEnd"
												data-test-id="jobs__date-range-end"
												type="date"
												className="form-control"
												min={filters.startDate}
												value={filters.endDate}
												onChange={event =>
													this.handleDateInputChange("endDate", event)
												}
											/>
										</Otherwise>
									</Choose>
								</div>
							</If>
							<If condition={user.isLEA() && user.Organization.UseZones}>
								<div className="col-sm-3 form-group">
									<label htmlFor="select-zone">{lang.t("Zone")}</label>
									<ReactSelect
										id="select-zone"
										name="select-zone"
										value={parseInt(filters.zoneId, 10)}
										onChange={this.handleZoneChange}
										options={zones}
										isLoading={loadingZones}
										isClearable
										dataTestId="jobs__select-zone"
									/>
								</div>
							</If>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-tags">{lang.t("Tags")}</label>
								<ReactSelect
									id="select-tags"
									name="select-tags"
									value={parseInt(filters.jobTagId, 10)}
									onChange={this.handleTagChange}
									options={jobTags}
									isLoading={loadingJobTags}
									isClearable
									dataTestId="jobs__select-tags"
								/>
							</div>
							<div className="col-sm-3 form-group">
								<label htmlFor="select-invoiced-type">
									{lang.t("Invoice Type")}
								</label>
								<ReactSelect
									id="select-invoiced-type"
									name="select-invoiced-type"
									value={parseInt(filters.jobInvoicedType, 10)}
									onChange={this.handleJobInvoicedTypeChange}
									options={jobInvoicedTypes}
									isClearable
									dataTestId="jobs__select-invoice-type"
								/>
							</div>
						</div>
						<div className={`row switch-filters ${showFilters ? "" : "hidden-xs"}`}>
							<div className="col-xs-6 col-sm-3 col-lg-2">
								<Switch
									label={lang.t("Include Inactive")}
									onClick={() => this.updateFilters("includeInactive")}
									on={filters.includeInactive}
									data-test-id="jobs__include-inactive"
								/>
							</div>
							<div className="col-xs-6 col-sm-3 col-lg-2">
								<Switch
									label={`${lang.t("Only")} ${lang.t("Unstaffed")}`}
									onClick={() => this.updateFilters("unStaffed")}
									on={filters.unStaffed || activeGrid === "unstaffed"}
									disabled={activeGrid === "unstaffed"}
									data-test-id="jobs__only-unstaffed"
								/>
							</div>
							<div className="col-xs-6 col-sm-3 col-lg-2">
								<Switch
									label={lang.t("Include Deleted")}
									onClick={() => this.updateFilters("deleted")}
									on={filters.deleted}
									data-test-id="jobs__include-deleted"
								/>
							</div>
							<If
								condition={
									(user.isLEA() || user.isCoordinator()) && isPrepayEnabled
								}
							>
								<div className="col-xs-6 col-sm-3 col-lg-2">
									<Switch
										label={`${lang.t("Only")} ${lang.t("Prepaid")}`}
										onClick={() => this.updateFilters("prePay")}
										on={filters.prePay}
										data-test-id="jobs__only-prepaid"
									/>
								</div>
							</If>
							<If condition={activeGrid === "upcoming" || activeGrid === "unstaffed"}>
								<div className="col-xs-6 col-sm-3 col-lg-2">
									<Switch
										label={lang.t("Pending Applicants")}
										onClick={() => this.updateFilters("pendingApplicants")}
										on={filters.pendingApplicants}
									/>
								</div>
							</If>
						</div>
					</div>
					<Choose>
						<When condition={scheduleView}>
							<ScheduleView
								jobs={jobs}
								hasMore={hasMore}
								timezone={user.TimeZoneId}
								user={user}
								onScrollDetect={() => {
									this.getJobs();
									this.getJobCounts();
								}}
							/>
						</When>
						<Otherwise>
							<div className="row column-headers hidden-xs v-align">
								<If condition={!user.IsViewOnly}>
									<div
										className={`row v-align ${activeGrid === "completed" || user.isSuperAdmin() ? "hidden" : "checkbox"}`}
									>
										<label htmlFor="selectAllJobs">
											<input
												type="checkbox"
												id="selectAllJobs"
												data-test-id="jobs__select-all-jobs"
												name="selectAllJobs"
												checked={
													selectedJobs.length === selectableJobCount &&
													selectedJobs.length !== 0
												}
												title="Select/deselect all your agency's jobs"
												onClick={e => e.stopPropagation()}
												onChange={() => this.toggleSelectAllJobs()}
											/>
										</label>
									</div>
								</If>
								<div
									className="col-sm-3"
									role="button"
									tabIndex="0"
									onClick={() => this.updateSortCriteria("Job")}
									data-test-id="jobs__sort-by-job"
									onKeyPress={({ key }) => {
										if (key === "Enter") this.updateSortCriteria("Job");
									}}
								>
									<strong>{lang.t("Job")}</strong>
									<If condition={filters.sortBy === "Job"}>
										<i
											className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
										/>
									</If>
								</div>
								<div
									className={activeGrid === "completed" ? "col-sm-7" : "col-sm-6"}
								>
									<div
										className="col-sm-4"
										role="button"
										tabIndex="0"
										data-test-id="jobs__sort-by-location"
										onClick={() => this.updateSortCriteria("Location")}
										onKeyPress={({ key }) => {
											if (key === "Enter")
												this.updateSortCriteria("Location");
										}}
									>
										<strong>{lang.t("Location")}</strong>
										<If condition={filters.sortBy === "Location"}>
											<i
												className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
											/>
										</If>
									</div>
									<div className="col-sm-4">
										<strong
											className={`${activeGrid === "completed" ? "" : "officer-header-alignment"}`}
										>
											{lang.t("Officer")}
										</strong>
									</div>
									<div
										className="col-sm-4"
										role="button"
										tabIndex="0"
										onClick={() => this.updateSortCriteria("StartDateTime")}
										onKeyPress={({ key }) => {
											if (key === "Enter")
												this.updateSortCriteria("StartDateTime");
										}}
									>
										<strong
											className={`${activeGrid === "completed" ? "" : "date-header-alignment"}`}
										>
											{lang.t("Date")}
										</strong>
										<If condition={filters.sortBy === "StartDateTime"}>
											<i
												className={`glyphicon glyphicon-triangle-${filters.asc ? "top" : "bottom"}`}
											/>
										</If>
									</div>
								</div>
							</div>
							<div className="list-body">
								<For
									each="job"
									of={jobs}
								>
									<div
										key={`check_${job.Id}`}
										className={`row${job.Deleted ? " deleted-job" : ""}`}
									>
										<If condition={!user.IsViewOnly}>
											<div
												role="button"
												aria-label="Save"
												onClick={() =>
													job.AgencyId !== user.Organization.Id ||
													job.Deleted
														? {}
														: this.updateSelectedJobs(job.Id)
												}
												onKeyDown={() =>
													job.AgencyId !== user.Organization.Id ||
													job.Deleted
														? {}
														: this.updateSelectedJobs(job.Id)
												}
												disabled={
													job.AgencyId !== user.Organization.Id ||
													job.Deleted
												}
												className={
													activeGrid === "completed" ||
													user.isSuperAdmin()
														? "hidden"
														: "col-xs-12 col-sm-1 checkbox"
												}
											>
												<label htmlFor={`check_${job.Id}`}>
													<input
														type="checkbox"
														id={`check_${job.Id}`}
														name={`check_${job.Id}`}
														checked={selectedJobs.some(
															({ Id }) => Id === job.Id,
														)}
														disabled={
															job.AgencyId !== user.Organization.Id ||
															job.Deleted
														}
														title={
															job.AgencyId !== user.Organization.Id
																? lang.t(
																		"This job cannot be selected since it is not managed by your agency",
																	)
																: undefined
														}
														onChange={() =>
															this.updateSelectedJobs(job.Id)
														}
														onClick={e => e.stopPropagation()}
													/>
												</label>
											</div>
										</If>
										<Link
											key={`job_${job.Id}`}
											to={`/jobs/${job.Id}`}
											id={`key_job_${job.Id}`}
										>
											<div className="container no-padding no-margin row">
												<div className="col-xs-12 col-sm-3">
													{/* <div className="col-xs-12 col-sm-12"> */}
													<div className="job-name overflow-job-name">
														<strong>{job.Name}</strong>
														(#{job.Id})
													</div>
													{job.ClientName}
													<br />
													<If condition={!user.isCoordinator()}>
														<strong>{lang.t("Project")}: </strong>
														{job.ProjectName}
														<br />
													</If>
													<If condition={job.ApplicantsPending > 0}>
														<button
															type="button"
															className="btn btn-link new-apps"
															data-test-id="jobs__new-apps-btn"
															onClick={e => {
																e.preventDefault();
																this.openManualAssignModal(job);
															}}
														>
															{/* eslint-disable-next-line camelcase */}
															{lang.t("dynamic.New Applicant", {
																smart_count: job.ApplicantsPending,
															})}
														</button>
														<br />
													</If>
													<If
														condition={
															job.AgencyId !== user.Organization.Id
														}
													>
														<strong>{lang.t("Agency")}: </strong>
														{job.AgencyName}
														<br />
													</If>
													{this.renderPostedStatus(job)}
													<If condition={job.JobEventRecurrenceRuleId}>
														<br />
														<button
															type="button"
															className="btn btn-link filter-recurrence"
															data-test-id="jobs__filter-recurrence"
															onClick={e => {
																e.preventDefault();
																this.changeRecurrenceFilter(
																	job.JobEventRecurrenceRuleId,
																);
															}}
														>
															<i className="glyphicon glyphicon-refresh" />
															&nbsp;
															{lang.t("Recurring")} {lang.t("Job")} (
															{job.JobEventRecurrenceRuleId})
														</button>
													</If>
													{/* </div> */}
												</div>
												<div
													className={`col-xs-12 ${activeGrid === "completed" ? "col-sm-7" : "col-sm-6 fix-alignment"}`}
												>
													<div className="col-xs-12 col-sm-4">
														<strong>{job.LocationName}</strong>
														<br
															className={
																job.LocationName ? "" : "hidden"
															}
														/>
														{job.LocationAddress}
														<br
															className={
																job.LocationAddress ? "" : "hidden"
															}
														/>
														{job.LocationCity}
														{job.LocationCity && job.LocationState
															? ", "
															: ""}
														{job.LocationState}
														&nbsp;
														{job.LocationZipcode}
													</div>
													<div className="col-xs-6 col-sm-4">
														{this.renderAssignedOfficers(job)}
														<If
															condition={
																(job.ApplicantsAssigned === 0 &&
																	job.ApplicantsNeeded <= 1) ||
																(job.ApplicantsAssigned >= 0 &&
																	job.ApplicantsNeeded > 1)
															}
														>
															{`${job.Jobs.length} position${job.Jobs.length !== 1 ? "s" : ""}`}
															<span className="hidden-xs">
																&nbsp; &#183; &nbsp;
															</span>
															<br className="visible-xs" />
															<span className="text-lowercase">
																{`${job.ApplicantsAssigned}/${job.ApplicantsNeeded} ${lang.t("Staffed")}`}
															</span>
															<br />
															<If
																condition={
																	!utils.doItHavePayCodeAdded(
																		job.Jobs,
																		PayCodesEnabled,
																	)
																}
															>
																<span className="hidden-xs hidden-sm">
																	{lang.t("Officer Rate")}:
																</span>
																<span className="visible-xs-inline visible-sm-inline">
																	{lang.t("Rate")}:
																</span>
																&nbsp;
																{job.MinRate === job.MaxRate
																	? `${utils.currencyFormatter(job.MinRate, false)}/hour`
																	: `${utils.currencyFormatter(job.MinRate, false)} - ${utils.currencyFormatter(job.MaxRate, false)}/hour`}
																<br />
															</If>
															<Choose>
																<When
																	condition={
																		job.ApplicantsAssigned === 0
																	}
																>
																	<span className="label label-danger">
																		{lang.t("Unstaffed")}
																	</span>
																</When>
																<When
																	condition={
																		job.ApplicantsAssigned <
																		job.ApplicantsNeeded
																	}
																>
																	<span className="label label-warning">
																		{lang.t("Understaffed")}
																	</span>
																</When>
																<When
																	condition={
																		job.ApplicantsAssigned ===
																			job.ApplicantsNeeded &&
																		job.ApplicantsAssigned !== 1
																	}
																>
																	<span className="label label-success">
																		{lang.t("Staffed")}
																	</span>
																</When>
															</Choose>
														</If>
														<If condition={job.RequirePrepayment}>
															<span
																className="label label-success text-uppercase"
																title={lang.t(
																	"This job has been prepaid, no overtime hours are allowed_",
																)}
															>
																{lang.t("Prepaid")}
															</span>
														</If>
														{ !job.RequirePrepayment && job.HasNonRKPayInvoiceEstimate && (
															<>
																{ job.IsNonRKPayInvoiceEstimatePaid && (
																	<span className="label label-success">
																		{lang.t("Prepaid")}
																	</span>
																)}
																{ !job.IsNonRKPayInvoiceEstimatePaid && (
																	<span className="label label-danger">
																		{lang.t("Prepay")}
																	</span>
																)}
															</>
														)}
													</div>
													<div className="col-xs-6 col-sm-4">
														<div>{this.renderDateRange(job)}</div>
														<small>
															{utils.formatTime(
																new Date(`${job.StartDateTime}Z`),
																user.UserPreferences !==
																	"useMilitaryTime",
																user.TimeZoneId,
															)}
															&nbsp;-&nbsp;
															{utils.formatTime(
																new Date(`${job.EndDateTime}Z`),
																user.UserPreferences !==
																	"useMilitaryTime",
																user.TimeZoneId,
															)}
															<If
																condition={(job.Jobs || []).some(
																	position => position.FlexJob,
																)}
															>
																&nbsp;
																<span
																	className="label label-info"
																	title={
																		job.JobEventTypeId ===
																		FORM_JOB_TYPES.EVENT.value
																			? lang.t(
																					"This event contains flexible shifts",
																				)
																			: `${job.Jobs.find(pos => pos.FlexJob).FlexJobMinHours} ${lang.t("Hr Minimum")}`
																	}
																>
																	{lang.t("FLEX")}
																</span>
															</If>
														</small>
														<Choose>
															<When
																condition={
																	activeGrid !== "active" &&
																	activeGrid !== "completed"
																}
															>
																<div>
																	<em>
																		{this.timeToJobStart(
																			job.StartDateTime,
																		)}
																	</em>
																</div>
															</When>
															<When
																condition={
																	job.ApplicantsNeeded ===
																		job.ApplicantsAssigned &&
																	job.ApplicantsAssigned === 1
																}
															>
																<div className="officer-clockinfo">
																	<div>
																		{lang.t("Clock In")}
																		<br />
																		{job?.Jobs[0]
																			?.AssignedOfficers[0]
																			?.ClockIn
																			? utils.formatTime(
																					new Date(
																						`${job?.Jobs[0]?.AssignedOfficers[0]?.ClockIn}Z`,
																					),
																					user.UserPreferences !==
																						"useMilitaryTime",
																					user.TimeZoneId,
																				)
																			: "--"}
																	</div>
																	<div>
																		{lang.t("Clock Out")}
																		<br />
																		{job?.Jobs[0]
																			?.AssignedOfficers[0]
																			?.ClockOut
																			? utils.formatTime(
																					new Date(
																						`${job?.Jobs[0]?.AssignedOfficers[0]?.ClockOut}Z`,
																					),
																					user.UserPreferences !==
																						"useMilitaryTime",
																					user.TimeZoneId,
																				)
																			: "--"}
																	</div>
																</div>
															</When>
														</Choose>
													</div>
												</div>
												<div className="col-xs-12 col-sm-2">
													<div className="row">
														<Choose>
															<When condition={job.Deleted}>
																<div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-12">
																	<button
																		type="button"
																		className="btn btn-success btn-block restore-job"
																		onClick={this.restoreJob(
																			job,
																		)}
																		disabled={user.IsViewOnly}
																	>
																		{lang.t("Restore")}
																	</button>
																</div>
															</When>
															<Otherwise>
																<div className="col-xs-6 col-xs-offset-3 col-sm-offset-0 col-sm-12">
																	<If
																		condition={
																			job.Jobs.length > 1
																		}
																	>
																		<button
																			type="button"
																			className="btn btn-default btn-block view-positions-btn"
																			onClick={e => {
																				e.preventDefault();
																				this.openMultiPositionModal(
																					job,
																				);
																			}}
																		>
																			{lang.t("Positions")}
																		</button>
																	</If>
																	<If
																		condition={
																			job.Jobs.length === 1
																		}
																	>
																		<button
																			type="button"
																			className="btn btn-primary btn-block edit-assignment-btn"
																			onClick={e => {
																				e.preventDefault();
																				this.openManualAssignModal(
																					job,
																				);
																			}}
																			disabled={
																				!utils.getJobActionPermissions(
																					user,
																					job,
																				).allowAssign &&
																				!utils.getJobActionPermissions(
																					user,
																					job,
																				).allowUnassign
																			}
																			title={
																				!utils.getJobActionPermissions(
																					user,
																					job,
																				).allowAssign &&
																				!utils.getJobActionPermissions(
																					user,
																					job,
																				).allowUnassign
																					? lang.t(
																							"dynamic.Assignment managed by",
																							{
																								agency: job.AgencyName,
																							},
																						)
																					: undefined
																			}
																		>
																			{lang.t("Assign")}
																		</button>
																		<If
																			condition={
																				activeGrid ===
																					"completed" &&
																				!user.isSuperAdmin()
																			}
																		>
																			<button
																				type="button"
																				className="btn btn-danger btn-block"
																				onClick={e => {
																					e.preventDefault();
																					this.openDeleteConfirmationModal(
																						job,
																					);
																				}}
																				disabled={
																					deletingJob ===
																						job.Id ||
																					!utils.getJobActionPermissions(
																						user,
																						job,
																					)
																						.allowDeleteAbandonedJob
																				}
																				title={
																					!utils.getJobActionPermissions(
																						user,
																						job,
																					)
																						.allowDeleteAbandonedJob
																						? lang.t(
																								"Jobs can be only deleted by the agency that manages the job",
																							)
																						: undefined
																				}
																			>
																				<Choose>
																					<When
																						condition={
																							deletingJob ===
																							job.Id
																						}
																					>
																						<i className="rkf rkf-spinner rkf-spin rkf-fw" />
																					</When>
																					<Otherwise>
																						{lang.t(
																							"Delete Job",
																						)}
																					</Otherwise>
																				</Choose>
																			</button>
																		</If>
																	</If>
																</div>
															</Otherwise>
														</Choose>
													</div>
												</div>
												<If
													condition={
														canDisplayRibbon &&
														(job.JobInvoicedTypeId === 1 ||
															job.JobInvoicedTypeId === 2)
													}
												>
													<RKPayRibbon />
												</If>
											</div>
										</Link>
									</div>
								</For>
							</div>
							<If condition={hasMore}>
								<ScrollDetect
									className="text-center"
									onVisible={() => {
										this.getJobs();
										this.getJobCounts();
									}}
								>
									<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
								</ScrollDetect>
							</If>
							<div
								className={`bulk-actions${selectedJobs.length > 0 ? " shown" : ""}`}
							>
								<div className="row bulk-button-container">
									<div className="col-xs-12 col-sm-3 col-md-2">
										<If
											condition={
												isInvoicingV3 &&
												selectedJobs.every(job => !job.IsRKPay) &&
												activeGrid !== "active" &&
												selectedJobClients.length === 1 &&
												!jobListAddToEstimateButtonEnabled
											}
										>
											<button
												type="button"
												className="btn btn-default btn-block"
												data-test-id="jobs__create-estimate"
												onClick={this.createEstimateFromJobs}
											>
												{lang.t("Create Estimate")}
											</button>
										</If>
										<If
											condition={jobListAddToEstimateButtonEnabled}
										>
											<button
												type="button"
												className="btn btn-default btn-block"
												data-test-id="jobs__add-to-estimate"
												onClick={() => this.setState({ showAddToEstimateModal: true })}
												disabled={!canShowAddToEstimate}
												title={!canShowAddToEstimate ? lang.t("AddToEstimateDisableButtonMessage") : ""}
											>
												{lang.t("Add to Estimate")}
											</button>
										</If>
									</div>
									<div className="col-xs-12 col-sm-3 col-md-2">
										<button
											type="button"
											className={
												isBulkAvailable
													? "btn btn-default btn-block"
													: "btn btn-default btn-block disabled-button"
											}
											data-test-id="jobs__bulk-assign"
											disabled={!isBulkAvailable}
											onClick={() =>
												this.openBulkAssignModal(selectedJobs[0])
											}
										>
											<span className="text-primary">
												{lang.t("Assign Officer")}
											</span>
										</button>
									</div>
									<div className="col-xs-12 col-sm-3 col-md-2">
										<button
											type="button"
											className="btn btn-default btn-block"
											data-test-id="jobs__post-selected"
											onClick={() =>
												this.setState({ showPostJobModal: true })
											}
										>
											<span className="text-primary">
												{lang.t("Post Selected")}
											</span>
										</button>
									</div>
									<div className="col-xs-12 col-sm-3 col-md-2">
										<button
											type="button"
											className="btn btn-default btn-block"
											data-test-id="jobs__bulk-delete"
											onClick={() => this.openBulkDeleteConfirmationModal()}
											disabled={bulkDeletingJobs}
										>
											<Choose>
												<When condition={bulkDeletingJobs}>
													<i className="rkf rkf-spinner rkf-spin rkf-fw" />
												</When>
												<Otherwise>
													<span className="text-danger">
														{lang.t("Delete Selected")}
													</span>
												</Otherwise>
											</Choose>
										</button>
									</div>
								</div>
							</div>
							<ManualAssignModal
								show={manualAssignModal.show}
								defaultPosition={manualAssignModal.defaultPosition}
								isActiveJob={manualAssignModal.isActiveJob}
								timeZoneId={user.TimeZoneId}
								isSuperAdmin={user.isSuperAdmin()}
								isLEA={user.isLEA()}
								isStaffAdmin={!!user?.IsStaffAdmin}
								positions={manualAssignModal.positions}
								recurrenceRule={manualAssignModal.recurrenceRule}
								isAgencyW2={user.Organization.TransferOfficerPaymentToJurisdiction}
								isPrepayJob={manualAssignModal.isPrepayJob}
								isRKPayJob={manualAssignModal.isRKPayJob}
								closeModal={this.closeManualAssignModal}
								jurisdictionId={user.Organization.JurisdictionId}
								isViewOnly={user.IsViewOnly}
							/>
							<BulkAssignModal
								show={bulkAssignModal.show}
								defaultPosition={bulkAssignModal.defaultPosition}
								isActiveJob={bulkAssignModal.isActiveJob}
								timeZoneId={user.TimeZoneId}
								isSuperAdmin={user.isSuperAdmin()}
								isLEA={user.isLEA()}
								positions={bulkAssignModal.positions}
								recurrenceRule={bulkAssignModal.recurrenceRule}
								isAgencyW2={user.Organization.TransferOfficerPaymentToJurisdiction}
								isPrepayJob={bulkAssignModal.isPrepayJob}
								isRKPayJob={bulkAssignModal.isRKPayJob}
								selectedJobs={selectedJobs}
								closeModal={this.closeBulkAssignModal}
								jurisdictionId={user.Organization.JurisdictionId}
								refreshResults={this.finishBulkAssignment}
							/>
							<MultiPositionModal
								show={multiPositionModal.show}
								timezone={user.TimeZoneId}
								onCancel={this.closeMultiPositionModal}
								jobEvent={multiPositionModal.job}
								jobPermissions={utils.getJobActionPermissions(
									user,
									multiPositionModal.job,
								)}
								onEditAssignment={this.openManualAssignModal}
							/>
							<PostJobModal
								show={showPostJobModal}
								updateAllUpcoming={false}
								selectedJobs={selectedJobs}
								closeModal={() => this.setState({ showPostJobModal: false })}
								postingFromList
								organization={user.Organization}
								user={user}
								successCallback={() => this.postJobSuccessCallback()}
							/>
							<ConfirmationModal ref={this.confirmationModal} />
							<JobSeriesDeleteModal
								show={showJobSeriesDeleteModal}
								bulkDeleting={selectedJobs.length > 1}
								onConfirm={deleteAllUpcoming => {
									if (selectedJobs.length > 1)
										this.confirmBulkDeleteJobs(deleteAllUpcoming);
									else this.confirmDeleteJob(deleteAllUpcoming);
								}}
								onCancel={() => this.setState({ deletingJob : undefined, showJobSeriesDeleteModal : false })}
							/>
							<JobSeriesRestoreModal
								show={jobToRestoreSeries !== undefined}
								onConfirm={restoreAll =>
									this.handleRestore(restoreAll, jobToRestoreSeries)
								}
								onCancel={() => this.setState({ jobToRestoreSeries: undefined })}
							/>
						</Otherwise>
					</Choose>
					<JobsMapModal
						timezone={user.TimeZoneId}
						user={user}
						show={showMapModal}
						onCancel={this.toggleMapModal}
						activeGrid={activeGrid}
						jobs={jobs}
					/>
					<AddToEstimateModal
						show={showAddToEstimateModal}
						onHide={() => this.setState({ showAddToEstimateModal: false })}
						jobs={selectedJobs}
						user={user}
						onCreateNewEstimate={this.createEstimateFromJobs}
						handleAddToEstimate={this.handleAddToEstimate}
					/>
				</div>
			</Fragment>
		);
	}
}

JobsList.propTypes = {
	flags: PropTypes.object.isRequired,
	user: PropTypes.object,
	router: PropTypes.object,
	location: PropTypes.shape({
		query: PropTypes.object,
		pathname: PropTypes.string,
	}),
};

JobsList.defaultProps = {
	user: {},
	router: {},
	location: { query: {}, pathname: "" },
};

export default withLDConsumer()(JobsList);
